import '@/sass/tokens/_root.scss'; // Flexigo design tokens (:root CSS custom properties)

import Vue from 'vue';

/* eslint-disable no-unused-vars */
import { Dropdown, Tooltip } from 'bootstrap';
/* eslint-enable no-unused-vars */

/* eslint-disable import/no-duplicates */
import { LicenseManager } from 'ag-grid-enterprise';
import 'ag-grid-enterprise';
/* eslint-enable import/no-duplicates */

import * as VueGoogleMaps from 'vue2-google-maps';
import VueI18n from 'vue-i18n';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faEyeSlash, faEye, fas } from '@fortawesome/free-solid-svg-icons';

/* these could be removed if not used */
import VTooltip from 'v-tooltip';
import VModal from 'vue-js-modal';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as filters from '@/helpers/filters';
import { isKurogoWebview } from '@/helpers/utility';

import App from '@/shells/ShellChooser.vue';
import messages from '../../../locale/i18n';

import router from './router';
import store from './store/store';

import {
  // requestNotificationPermission,
  // hasNotificationPermission,
  // sendToServiceWorker,
} from './helpers/notifications';
import { languageSelector } from './helpers/utility';
import { initRum } from './helpers/rum';

LicenseManager.setLicenseKey("CompanyName=Vektor,LicensedApplication=Vektor,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-018092,ExpiryDate=17_August_2022_[v2]_MTY2MDY5MDgwMDAwMA==32548f96502ae146d0f3bd08785a1784");

// library.add(faEyeSlash);
// library.add(faEye);
// library.add(fas);
// Vue.component('fa-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

// Global Filters
Vue.filter('date', filters.date);
Vue.filter('time', filters.time);
Vue.filter('tl', filters.tl);
Vue.filter('fulltime', filters.fulltime);

LicenseManager.setLicenseKey('CompanyName=Vektor,LicensedApplication=Vektor,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-018092,ExpiryDate=17_August_2022_[v2]_MTY2MDY5MDgwMDAwMA==32548f96502ae146d0f3bd08785a1784');

Vue.use(VueI18n);

// Google Map Config
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD5hb_jNij_4wNa1hUkPPk2zSb8HgmvQtY',
    // TEMPORARY: pinned to v3.64 because the drawing library (DrawingManager) was removed in v3.65+.
    // v3.64 is loadable until ~mid-Feb 2027 - replace DrawingManager before then.
    v: '3.64',
    libraries: 'places,visualization,drawing,geometry', // This is required if you use the Autocomplete plugin
    language: languageSelector(),
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  },
  installComponents: true,
});

Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false }, dialog: true });
Vue.use(VTooltip);

const lang = languageSelector();
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: lang,
  messages,
});
Vue.config.lang = lang;
console.log(lang);
// library.add(fas);
// Vue.component('fa-icon', FontAwesomeIcon);

Vue.mixin({
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
});

// Notifications start
// if (!hasNotificationPermission()) {
//   requestNotificationPermission();
// }

// Notifications end

// Datadog RUM page and feature usage; does nothing on unknown hosts and never throws
initRum({ i18n, isKurogo: isKurogoWebview() });

// `navigator.serviceWorker` is undefined - not just unusable - in iOS WKWebView (unless the
// host app opts into App-Bound Domains) and in Safari private browsing. Reading `.register`
// off it throws, which aborts this entry module before $mount below and leaves the static
// loader in template.html on screen forever. Guard, as the message listener further down does.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/admin/service-worker.js').then(() => {
    console.log('Service Worker registered successfully.');
  }).catch((error) => {
    console.log('Service Worker registration failed:', error);
  });
}

// setInterval(() => {
//   console.log('readyState', eventSource.readyState, new Date());
//   showNotification('test', { body: 'test', icon: '/admin/flexigo-loader.gif' });
// }, 30000);

const app = new Vue({ // eslint-disable-line no-unused-vars
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

// Initialize SSE service with i18n instance after Vue app is created
// The SSE plugin will handle authentication-based connection management
// NOW USING BROADCASTCHANNEL FOR SINGLE SSE CONNECTION PER BROWSER
// Only leader tabs establish actual SSE connection, followers receive via BroadcastChannel
// Vue 3 Compatible: Uses framework-agnostic callback pattern
if (store.$initializeSSE) {
  store.$initializeSSE(i18n);
}

// Listen for navigation messages from service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    const { type, routeName, routeParams, routeQuery, url } = event.data;

    if (type === 'NAVIGATE_TO_ROUTE' && routeName) {
      console.log('Navigating to route:', routeName);
      app.$router.push({
        name: routeName,
        params: routeParams || {},
        query: routeQuery || {}
      }).catch((err) => {
        console.log('Navigation error:', err.name);
      });
    } else if (type === 'NAVIGATE_TO_URL' && url) {
      console.log('Navigating to URL:', url);
      app.$router.push(url).catch((err) => {
        console.log('Navigation error:', err.name);
      });
    }
  });
}
